import { TableRow, VenueObject } from './table.types';

export const STATUS_COLOR: Record<number, string> = {
  2: '#2e7d32',
  3: '#ed6c02',
  4: '#d32f2f',
};

export function stripHtml(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}

export function getVenueLabel(venue: TableRow['venue']): string {
  if (!venue) return '';

  if (typeof venue === 'string') return venue;

  const v = venue as VenueObject;
  const name = v.name ?? '';
  const address = v.address_line1 ?? '';

  if (name && address && name !== address) {
    return `${name} (${address})`;
  }

  return name || address || '';
}

export function getEntityName(value: unknown): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null && 'name' in value) {
    return String((value as { name?: string }).name ?? '');
  }
  return '';
}

export function hasRequiredFields(requiredFields: Record<string, boolean> | string[] | undefined): boolean {
  if (!requiredFields) return false;
  if (Array.isArray(requiredFields)) return requiredFields.length > 0;
  return Object.keys(requiredFields).length > 0;
}

export function normalizeRows(rows: TableRow[]) {
  return rows.map((row) => ({
    ...row,
    activity_name: getEntityName(row.activity),
    group_name: getEntityName(row.group),
    service_provider_name: stripHtml(row.service_provider?.name ?? ''),
    type_name: row.type?.name ?? '',
    type_color: row.type?.hex_color ?? '',
    venue_label: getVenueLabel(row.venue),
    confirmation_status_name: row.confirmation_status?.name ?? 'Pending',
    confirmation_status_id: row.confirmation_status?.id ?? 0,
  }));
}

export async function copySelectedRowsToClipboard(
  apiRef: any,
  rows: TableRow[]
): Promise<string> {
  const selectedIds = apiRef.current.getSelectedRows();
  if (!selectedIds.size) {
    throw new Error('Nincs kijelölt sor');
  }

  const selectedRows = Array.from(selectedIds.values()) as TableRow[];

  const text = selectedRows
    .map((row) => {
      return [
        row.type?.name ?? '',
        stripHtml(row.service_provider?.name ?? ''),
        getEntityName(row.activity),
        getEntityName(row.group),
        row.group_size ?? '',
        row.date ?? '',
        row.start_time ?? '',
        getVenueLabel(row.venue),
        row.confirmation_status?.name ?? 'Pending',
      ].join('\t');
    })
    .join('\n');

  await navigator.clipboard.writeText(text);
  return text;
}